<template>
    <div class="report-warp">
        <div class="my-panel">
            <div class="my-reward">
                <div class="title">我的奖励</div>
                <div class="price">
                    <div class="icon">¥</div>
                    <div class="price-name">{{ total || ''}}</div>
                </div>
            </div>
            <div class="new-msg">
                {{ valid_share }}
<!--                <span>+{{ 80 }}元</span>-->
            </div>
        </div>
        <div class="data-panel">
            <div class="search-box">
                <div :class="['time-box',{'time-act':nTimeIndex == 0}]" @click="touchTime(0)">{{ startTime.text }}</div>
                至
                <div :class="['time-box',{'time-act':nTimeIndex == 1}]" @click="touchTime(1)">{{ endTime.text }}</div>
            </div>
            <div class="data-list">
                <template v-for="(item,index) in arrData">
                    <div :key="index" class="data-item">
                        <div class="title">{{ item.title }}</div>
                        <div class="data-box">
                            <template v-for="(data,dataIndex) in item.data">
                                <div :class="['value-item',{'desc-item':data.desc}]">
                                    <div class="name">{{ data.name }}</div>
                                    <div class="value">{{ data.value }}</div>
                                    <div v-if="data.desc" class="desc">分享可得{{ data.desc }}元</div>
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
            </div>
        </div>


        <van-popup v-model="isTimePciker" round position="bottom">
            <div class="timepicker-wrap">
                <van-datetime-picker
                    type="date"
                    v-model="dateValue"
                    :title="dateTitle"
                    :min-date="minDate"
                    :max-date="maxDate"
                    @confirm="onDateConfirm"
                />
            </div>
        </van-popup>
    </div>
</template>

<script>
import oWarm from '@/js/hvac/dossier/warm'

export default {
    name: "archivesUserReport",
    data() {
        return {
            total:'',//累计收益
            valid_share:'',//文字
            nTimeIndex: -1, //选中时间索引
            arrData: [{
                title: '个人项目交付进展',
                key:1,
                data: [{
                    name: '已分享(次)',
                    value: '',
                    key:'shared_num',
                }, {
                    name: '有效交付(次)',
                    value: '',
                    key:'valid_num',
                }, {
                    name: '待分享(次)',
                    value: '',
                    key:'wait_num',
                    desc: ''
                }]
            }, {
                title: '城市项目交付进展',
                key:2,
                data: [{
                    name: '已分享(次)',
                    value: '',
                    key:'shared_num',
                }, {
                    name: '有效交付(次)',
                    value: '',
                    key:'valid_num',
                }, {
                    name: '待分享(次)',
                    value: '',
                    key:'wait_num',
                }, {
                    name: '有效分享项目(个)',
                    value: '',
                    key:'valid_project_num',
                }, {
                    name: '待分享项目(个)',
                    value: '',
                    key:'wait_project_num',
                }, {
                    name: '交付率(%)',
                    value: '',
                    key:'delivery_rate',
                }]
            }, {
                title: '城市口碑上线',
                key:3,
                data: [{
                    name: '口碑已上线',
                    value: '',
                    key:'online_num'
                }, {
                    name: '口碑待上线',
                    value: '',
                    key:'wait_online'
                }, {
                    name: '口碑大区排行',
                    value: '',
                    key:'region_rank'
                }, {
                    name: '评价(个)',
                    value: '',
                    key:'discuss_num'
                }, {
                    name: '评论排行',
                    value: '',
                    key:'discuss_rank'
                }]
            }/*, {
                title: '我的收藏',
                data: [{
                    name: '冷暖风水案例',
                    value: 2,
                }, {
                    name: '知识库文章',
                    value: 2,
                }]
            }*/],
            dateValue: '',
            dateTitle: '',
            minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 3)),
            maxDate: new Date(),
            isTimePciker: false,//是否展示时间选择器
            startTime: {
                text: '',
                value: '',
            },
            endTime: {
                text: '',
                value: '',
            },
        }
    },
    created() {
        this.timeInit();
        this.getInfo()
    },
    methods: {
        getInfo() {
            this.$store.commit('loadSwitch', true)
            console.log(this.startTime,this.endTime)
            oWarm.userInfoDetail({
                start_time:this.startTime.text.replaceAll('/','-'),
                end_time:this.endTime.text.replaceAll('/','-'),
            }).then(res => {
                this.$store.commit('loadSwitch', false)
                let result = res.data.data.result
                this.total=result.total
                this.arrData.forEach(item=>{
                    // 个人项目交付进展
                    if(item.key==1){
                        item.data= item.data.map(it=>{
                            it.value=result.seller[it.key]
                            if(it.desc!=undefined){
                                it.desc=result.seller.wait_money
                            }
                            return it
                        })
                    }else if(item.key==2){
                        item.data= item.data.map(it=>{
                            it.value=result.city_project[it.key]
                            return it
                        })
                    }else if(item.key==3){
                        item.data= item.data.map(it=>{
                            it.value=result.city_praise[it.key]
                            return it
                        })
                    }
                })
                console.log(res, '信息')
            })
        },
        timeInit() {
            let date = new Date();
            let yyyy = date.getFullYear();
            let mm = date.getMonth() + 1;
            let dd = date.getDate();
            this.startTime = {
                text: yyyy + '/' + (mm > 9 ? mm : '0' + mm)  + '/'+ '01',
                value: new Date(yyyy + '/' + mm + '/01')
            }
            this.endTime = {
                text: yyyy + '/' + (mm > 9 ? mm : '0' + mm) + '/' + (dd > 9 ? dd : '0' + dd),
                value: new Date(yyyy + '/' + mm + '/' + dd)
            }
        },
        touchTime(i) {
            if (i == 0) {
                this.minDate = new Date(new Date().setFullYear(new Date().getFullYear() - 3));
                this.maxDate = this.endTime.value;
                this.dateValue = this.startTime.value;
                this.dateTitle = '请选择开始时间';
            } else {
                this.minDate = this.startTime.value;
                this.maxDate = new Date();
                this.dateValue = this.endTime.value;
                this.dateTitle = '请选择结束时间';
            }
            this.nTimeIndex = i;
            this.isTimePciker = true;
        },
        onDateConfirm(e) {
            let date = new Date(e)
            let yyyy = date.getFullYear();
            let mm = date.getMonth() + 1;
            let dd = date.getDate();
            if (this.nTimeIndex == 0) {
                this.startTime = {
                    text: yyyy + '/' + (mm > 9 ? mm : '0' + mm)  + '/' + (dd > 9 ? dd : '0' + dd),
                    value: new Date(yyyy + '/' + mm + '/' + dd)
                }
            } else {
                this.endTime = {
                    text: yyyy + '/' + (mm > 9 ? mm : '0' + mm) + '/' + (dd > 9 ? dd : '0' + dd),
                    value: new Date(yyyy + '/' + mm + '/' + dd)
                }
            }
            this.getInfo()
            this.isTimePciker = false;
        },
    }
}
</script>

<style lang="scss" scoped>
@font-face {
    font-family: 'Abel-Regular';
    src: url("/src/assets/font/Abel-Regular.ttf");
}

.report-warp {
    width: 100vw;
    min-height: 100vh;
    padding-top: 32px;
    padding-bottom: env(safe-area-inset-bottom);
    background: #f9f9fb;

    .my-panel {
        width: 702px;
        background: #E7EEFF;
        border-radius: 16px;
        overflow: hidden;
        margin: 0 auto 32px;

        .my-reward {
            width: 100%;
            height: 262px;
            border-radius: 16px;
            //background: linear-gradient(180deg, #5868F8 0%, #192597 100%);
            background: url("~@/assets/images/archives/user/reward-bg.png");
            background-size: 100% 100%;

            .title {
                font-size: 28px;
                font-family: ABeeZee-Regular, ABeeZee;

                color: #FFFFFF;
                line-height: 34px;
                padding-left: 52px;
                padding-top: 26px;
                position: relative;
            }

            .title::after {
                content: '';
                position: absolute;
                bottom: 5px;
                left: 32px;
                width: 4px;
                height: 24px;
                background: #FFFFFF;
            }

            .price {
                padding-top: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .icon {
                width: 48px;
                height: 48px;
                background: rgba(255, 255, 255, 0.7);
                display: block;
                margin-right: 4px;
                border-radius: 50%;
                font-size: 40px;
                line-height: 48px;
                text-align: center;
                color: #3746CB;
            }

            .price-name {
                position: relative;
                font-size: 64px;
                font-family: ABeeZee-Regular, ABeeZee;

                color: #FFFFFF;
                line-height: 78px;
            }

            .price-name:after {
                content: '累计收益(元)';
                position: absolute;
                top: calc(100% + 20px);
                left: 50%;
                white-space: nowrap;
                line-height: 28px;
                font-size: 26px;
                font-family: Abel-Regular, Abel;

                color: rgba(255, 255, 255, 0.6);
                transform: translateX(-50%);
            }
        }


        .new-msg {
            width: 100%;
            height: 78px;
            padding: 0 34px;
            font-size: 28px;
            font-family: Abel-Regular, Abel;

            color: #EA5F56;
            line-height: 78px;
            display: flex;
            justify-content: space-between;

            span {
                display: block;
                letter-spacing: 1px;
            }
        }
    }

    .data-panel {
        width: 702px;
        background: #FFFFFF;
        border-radius: 16px 16px 16px 16px;
        margin: 0 auto 32px;
        padding: 32px 32px 0;

        .search-box {
            display: flex;
            align-items: center;
            justify-content: space-between;


            .time-box {
                width: 270px;
                height: 64px;
                border-radius: 16px;
                background: #FFFFFF;
                border: 1px solid #dedede;
                text-align: center;
                font-size: 24px;
                font-family: Abel-Regular, Abel;

                color: #666666;
                line-height: 64px;
            }

            .time-act {
                background: #e7eeff;
                border: 1px solid #e7eeff;
                color: #0D53FC;
            }
        }

        .data-list {
            margin-top: 48px;
            padding-bottom: 1px;

            .data-item {
                margin-bottom: 32px;
                background: #f9f9fb;
                border-radius: 16px;
                overflow: hidden;

                .title {
                    width: 100%;
                    height: 74px;
                    background: #edf1fb;
                    padding-left: 52px;
                    font-size: 24px;
                    font-family: Abel-Regular, Abel;
                    font-weight: 400;
                    color: #333333;
                    line-height: 74px;
                    position: relative;
                }

                .title::after {
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 32px;
                    width: 4px;
                    height: 26px;
                    background: #0D53FC;
                    transform: translateY(-50%);
                }

            }

            .data-box {
                padding: 30px 30px 0;
                display: flex;
                align-items: flex-start;
                flex-wrap: wrap;
            }

            .value-item {
                width: 32%;
                height: 128px;
                position: relative;

                .name {
                    text-align: left;
                    font-size: 24px;
                    font-family: Abel-Regular, Abel;
                    color: #8B8B8B;
                    line-height: 38px;
                    padding-left: 18px;
                    white-space: nowrap;
                    margin-bottom: 8px;
                }

                .value {
                    font-size: 40px;
                    font-family: Abel-Regular, Abel;
                    color: #333333;
                    line-height: 50px;
                    padding-left: 60px;
                }

                .desc {
                    font-size: 20px;
                    font-family: Abel-Regular, Abel;
                    font-weight: 400;
                    color: #0D53FC;
                    line-height: 23px;
                    position: absolute;
                    left: 0;
                    bottom: 22px;
                    white-space: nowrap;
                }
            }

            .value-item:nth-child(3n+1) {
                width: 36%;
            }

            .desc-item {
                height: 150px;
            }
        }
    }
}


.timepicker-wrap {
    ::v-deep .van-picker__cancel {
        color: #333333;
        font-size: 32px;
    }

    ::v-deep .van-picker__confirm {
        color: #0D53FC;
        font-size: 32px;
    }

    ::v-deep .van-picker__title {
        color: #333333;
        font-size: 32px;
    }
}
</style>
